import React from 'react';
import { createRoot } from "react-dom/client";
import {dynamicImport} from './app/helpers/common';

// const render = () => {
// }
//
// if (
//     'fetch' in window &&
//     'Intl' in window &&
//     'URL' in window &&
//     'Map' in window &&
//     'forEach' in NodeList.prototype &&
//     'startsWith' in String.prototype &&
//     'endsWith' in String.prototype &&
//     'includes' in String.prototype &&
//     'includes' in Array.prototype &&
//     'assign' in Object &&
//     'entries' in Object &&
//     'keys' in Object
// ) {
//     render();
// } else {
//     import('babel-polyfill').then(render);
// }

const Dialogs = dynamicImport(/* #__LOADABLE__ */ () => import(/* webpackChunkName: "Dialogs" */ './app/components/Dialogs'));


try {
    // Create a new WebSocket.
    window.ws = new WebSocket(`${process?.env?.MIX_APP_WEBSOCKET_URL}`);
    window.addEventListener('beforeunload', function (e) {
        window.ws.close();
    });
} catch (error) {
    console.log('WebSocket Err', error);
}

if (document.getElementById('modals')) {
    const root = document.getElementById('modals');
    createRoot(root).render(<Dialogs />);
}

window.setPartner = (event, locationInfo) => {
    event = event || window.event;
    event.preventDefault();

    if (locationInfo) {
        // if (document.getElementById('app')) {
        //     store.dispatch(setSchool(locationInfo));
        //     history.push("/app/housing-questionnaire");
        // } else {
            localStorage.setItem('partnerInfo', JSON.stringify({
                id: locationInfo['id'],
                item: `${locationInfo['title']}`,
                location_type: locationInfo['type'] ?? 1,
                short_title: `${locationInfo['short_title']}`
            }));
            window.location.href = '/app/housing-questionnaire';
        // }
    }
}
